import { helperServices } from "../../shared/helper";
import history from "../../shared/utils/history";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.location.reload();
}

// -------------------- Handle Response --------------------
function handleResponse(response) {
  return response.text().then((text) => {
    let data;

    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = text;
    }

    const token = response.headers.get("Authorization");
    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
    }

    if (!response.ok) {
      if (response.status === 401) {
        logout();
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// -------------------- Headers --------------------
function buildHeaders() {
  const accessToken = helperServices.getAuthorization() || "";
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
}

/* =========================================================
   DASHBOARD / SESSIONS
========================================================= */

// Get Sessions (with filters + pagination)
function getSessions(params = {}) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const query = new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null)
    )
  ).toString();

  const url = `${basePath}/v1/dashboard/sessions${query ? `?${query}` : ""}`;

  return apiFetch(url, requestOptions);
}

// Update Session Status (Completed / Cancelled)
function updateSessionStatus(id, status, cancel_reason = "") {
  const requestOptions = {
    method: "PATCH",
    headers: buildHeaders(),
    body: JSON.stringify({
      status,
      cancel_reason,
    }),
  };

  const url = `${basePath}/v1/sessions/${id}/status`;

  return apiFetch(url, requestOptions);
}

/* =========================================================
   DOCTORS
========================================================= */

function getDoctorsList() {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/v1/doctors?limit=100`;

  return apiFetch(url, requestOptions);
}

/* =========================================================
   ROOMS
========================================================= */

function getRoomsList() {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/v1/rooms?facilityId=&roomStatus=`;

  return apiFetch(url, requestOptions);
}

/* =========================================================
   OPTIONAL UTIL (if needed later)
========================================================= */

// Get single session detail
function getSessionById(id) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/v1/sessions/${id}`;

  return apiFetch(url, requestOptions);
}

// Cancel session shortcut
function cancelSession(id, reason = "") {
  return updateSessionStatus(id, "Cancelled", reason);
}

// Complete session shortcut
function completeSession(id) {
  return updateSessionStatus(id, "Completed");
}

/* =========================================================
   EXPORT
========================================================= */

const sessionServices = {
  // core
  getSessions,
  updateSessionStatus,

  // helpers
  cancelSession,
  completeSession,
  getSessionById,

  // dropdowns
  getDoctorsList,
  getRoomsList,

  // utilities
  handleResponse,
  logout,
};

export default sessionServices;
